<template>
  <v-card
    flat
    tile
  >
  <v-card-title class="text-h4">{{ adminUserView.emailAddress }}</v-card-title>
    <v-card-text>
      <v-row align="stretch">
        <v-col md=4>
          <UserDetails></UserDetails>
        </v-col>
        <v-col md=8>
          <WalletLedger :userId="Number($route.params.id)"></WalletLedger>
        </v-col>
      </v-row>
      <v-row>
        <v-col md=12>
          <CurrentInvestments :userId="Number($route.params.id)"></CurrentInvestments>
        </v-col>
        <v-col md=12>
          <PastInvestments :userId="Number($route.params.id)"></PastInvestments>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import UserDetails from '../components/user/UserDetails.vue'
  import WalletLedger from '../components/user/WalletLedger.vue'
  import CurrentInvestments from '../components/user/CurrentInvestments.vue'
  import PastInvestments from '../components/user/PastInvestments.vue'

  export default {
    name: 'UserAccount',

    components: {
      UserDetails,
      WalletLedger,
      CurrentInvestments,
      PastInvestments
    },

    computed: {
      ...mapGetters([
        'adminUserView'
      ])
    },

    methods: {
      ...mapActions([
        'getUserById'
      ])
    },

    async created() {
      await this.getUserById(this.$route.params.id)
    }
  }
</script>
